import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

export const getCountryCode = (
	countryName: string | null | undefined
): string | undefined => {
	if (!countryName) return undefined;

	const trimmed = countryName.trim();
	if (!trimmed) return undefined;

	const code = countries.getAlpha2Code(trimmed, 'en');
	return code || undefined;
};
